import React from 'react'

const ModalDialogButton = ({
    buttonText,
    onClick
}) => (
    <button
        className="access-button access-dialog-open text-medium access-typo"
        type="button"
        onClick={onClick}
    >
        {buttonText}

    </button>
)

export default ModalDialogButton